import Footer from "../Component/Footer";
import Header from "../Component/Header";
import MessageList from "../Component/MessageList";
import { useCallback, useEffect, useRef, useState } from "react";
import ContactForm from "../Component/ContactForm";

function Contact() {
  const [questionAnswer, setQuestionAnswer] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [messages, setMessages] = useState([
    { text: "Hi There" },
    { text: "Oh hi!", isBot: true },
  ]);
  const chatContainerRef = useRef(null);
  const messageEndRef = useRef(null);

  const populateQuestionAnswer = useCallback(() => {
    setQuestionAnswer([
      {
        question: "Hi there!",
        answer: "Oh hi! Thanks for your greeting",
        url: "",
      },
      {
        question: "What is your social media?",
        answer:
          "I don't really active in my social media, but you can visit my github account",
        url: "https://github.com/RifalAli",
      },
      {
        question: "What are you doing lately?",
        answer: "Lately, I do working with web & mobile projects",
        url: "",
      },
    ]);
  }, []);

  useEffect(() => {
    populateQuestionAnswer();
  }, [populateQuestionAnswer]);

  useEffect(() => {
    const messageChoice = document.getElementById("message-choice");
    if (isLoading) {
      messageChoice.style.display = "none";
    } else {
      messageChoice.style.display = "flex";
    }
  }, [isLoading]);

  useEffect(() => {
    const scrollToBottom = () => {
      if (chatContainerRef.current && messageEndRef.current) {
        const container = chatContainerRef.current;
        const target = messageEndRef.current;

        const targetPosition = target.offsetTop;

        container.scrollTo({
          top: targetPosition,
          behavior: "smooth",
        });
      }
    };

    const timer = setTimeout(scrollToBottom, 50);

    return () => clearTimeout(timer);
  }, [messages, isLoading]);

  const handleUserChoice = (event) => {
    setIsLoading(true);
    const text = event.target.innerText;
    setMessages((prev) => [...prev, { text: text, isBot: false }]);

    setTimeout(() => {
      answerChat(text);
    }, 1500);
  };

  const answerChat = (text) => {
    setIsLoading(false);
    const item = questionAnswer.find((qa) => qa.question === text);
    if (item) {
      setMessages((prev) => [
        ...prev,
        { text: item.answer, url: item.url, isBot: true },
      ]);
    }
  };

  return (
    <div>
      <Header />
      <section className="bg-lightGray py-16 sm:py-24">
        <div className="container mx-auto px-4">
          <h1 className="text-4xl font-extrabold text-center text-gray-900 mb-4 sm:text-5xl">
            Let's <span className="text-crimson">Connect</span>
          </h1>
          <p className="text-center text-gray-600 mb-12 text-lg">
            Have a project or just want to chat? Pick a question or send a
            message!
          </p>

          <div className="max-w-4xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12">
            <div className="bg-white rounded-xl shadow-2xl p-4 flex flex-col h-[500px]">
              <h2 className="text-2xl font-bold text-gray-900 mb-4 border-b pb-2">
                Quick Chat
              </h2>

              <div
                id="chat-section"
                ref={chatContainerRef}
                className="flex-grow overflow-y-auto space-y-4 pr-2 custom-scrollbar"
              >
                {messages.map((item, index) => (
                  <MessageList key={index} item={item} />
                ))}

                {isLoading && (
                  <div className="flex justify-start items-center">
                    <div className="w-9 h-9 rounded-full object-cover mx-4">
                      <div className="w-3 h-3 bg-gray-400 rounded-full animate-pulse"></div>
                    </div>
                    <div className="bg-gray-200 text-gray-800 px-4 py-2 rounded-xl">
                      Typing...
                    </div>
                  </div>
                )}

                <div ref={messageEndRef} />
              </div>

              <div
                id="message-choice"
                className={`mt-4 pt-4 border-t ${
                  isLoading ? "hidden" : "flex"
                }`}
              >
                <div className="flex flex-wrap gap-2">
                  {questionAnswer.map((item, index) => (
                    <button
                      key={index}
                      onClick={handleUserChoice}
                      className="px-4 py-2 text-sm font-medium text-blue-700 bg-blue-100 rounded-full hover:bg-blue-200 transition duration-150 shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                    >
                      {item.question}
                    </button>
                  ))}
                </div>
              </div>
            </div>

            <ContactForm />
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}

export default Contact;
